import React, { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux';
import store from '../../store';
import { CHANGE_PAGE_action } from '../../store/actions/pageAction';
import { CREATE_EVENT_action } from '../../store/actions/eventAction';

import Sidebar from '../../components/Sidebar';
import Header from '../../components/Header';

// Componentes de Material UI
import { Button, Card, Avatar, ToggleButtonGroup, ToggleButton, Modal, Box, Grid, Paper, SpeedDial, SpeedDialIcon, SpeedDialAction } from '@mui/material';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';

import { styled, useTheme } from '@mui/material/styles';

import PropTypes from 'prop-types';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import IconButton from '@mui/material/IconButton';
import Skeleton from '@mui/material/Skeleton';


import default_image from '../../images/default_image.svg'

// Iconos
import MoreVertIcon from '@mui/icons-material/MoreVert';
import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import PersonIcon from '@mui/icons-material/Person';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import PartyModeIcon from '@mui/icons-material/PartyMode';
import { Visibility } from '@mui/icons-material';

// Otros iconos
import CampaignIcon from '@mui/icons-material/Campaign';
import CategoryIcon from '@mui/icons-material/Category'; // Icono para Tipo Evento "No definido"
import LiquorIcon from '@mui/icons-material/Liquor'; // Posible icono para Boliches
import CelebrationIcon from '@mui/icons-material/Celebration';
import TheaterComedyIcon from '@mui/icons-material/TheaterComedy'; // Icono para Tipo Evento "Teatro"
import ConnectingAirportsIcon from '@mui/icons-material/ConnectingAirports'; // Icono para Tipo Evento Viaje
import TravelExploreIcon from '@mui/icons-material/TravelExplore'; // Icono para Tipo Evento Nacional
import PetsIcon from '@mui/icons-material/Pets'; // Icono para Tipo Evento al Aire Libre
import PowerIcon from '@mui/icons-material/Power'; // Icono para Tipo Evento Virtual
import MusicNoteIcon from '@mui/icons-material/MusicNote'; // Icono para Tipo Evento Musical
import Diversity3Icon from '@mui/icons-material/Diversity3'; // Icono para Tipo Evento "Juntada"
import CakeIcon from '@mui/icons-material/Cake'; // Icono para Tipo Evento "Cumpleaños"
import WorkIcon from '@mui/icons-material/Work'; // Icono para Tipo Evento "Reunion Laboral"
import CloseIcon from '@mui/icons-material/Close';
import { GiDiamondRing } from "react-icons/gi"; // Icono para Tipo Evento "Casamiento"
import AddIcon from '@mui/icons-material/Add';
import EventIcon from '@mui/icons-material/Event';

// Iconos para las privacidades
import PublicIcon from '@mui/icons-material/Public';
import HttpsIcon from '@mui/icons-material/Https';
import { Stack } from 'react-bootstrap';
import SidebarResponsive from '../../components/SidebarResponsive';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { EVENTDETAILS_action } from '../../store/actions/eventDetailsAction';

import imagenPresentacion from '../../images/imagenPresentacion.png';
import axios from 'axios';
import AsyncStorage from '@react-native-async-storage/async-storage';
import CryptoJS from "crypto-js";
import ArrowRightRoundedIcon from '@mui/icons-material/ArrowRightRounded';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import KeyboardBackspaceRoundedIcon from '@mui/icons-material/KeyboardBackspaceRounded';
import { LOGIN_USER_action } from '../../store/actions/userAction';
import { TOKEN_action } from '../../store/actions/tokenAction';
import { requestPermissions, getFCMToken } from "../../services/firebase";

import imageCompression from 'browser-image-compression';
import BottomNavigationBar from '../../components/BottomNavigation';
import FloatingActionButton from '../../components/FloatingActionButton';
// Componentes de Joy UI


const mapStateToProps = (state) => {
    return {
        page: state.pageReducer.pageName,
        user: state.userReducer,
        searchEventTitle: state.searchEventReducer.searchTitle,
        searchEventCreator: state.searchEventReducer.searchCreator,
        token: state.tokenReducer.token
        // event: 
    }
}

const Map = ({ location }) => {
    useEffect(() => {
        console.log("map location")
        console.log(location)
        let map;

        const initMap = async () => {
            const geocoder = new window.google.maps.Geocoder();

            geocoder.geocode({ location: location }, (results, status) => {
                if (status === "OK") {
                    if (results[0]) {
                        console.log("Dirección encontrada:", results[0].formatted_address);
                    } else {
                        console.log("No se encontraron resultados.");
                    }
                } else {
                    console.error("Fallo en la geocodificación inversa: " + status);
                }
            });

            const position = { lat: location.lat, lng: location.lng };
            // const position = { lat: -32.4311892, lng: -63.72867609999999 };

            // Cargar bibliotecas de Google Maps
            const { Map } = await window.google.maps.importLibrary('maps');
            const { AdvancedMarkerElement } = await window.google.maps.importLibrary('marker');
            map = new Map(document.getElementById('map'), {
                zoom: 15,
                center: position,
                mapId: 'DEMO_MAP_ID',
            });

            new AdvancedMarkerElement({
                map: map,
                position: position,
                title: 'Uluru',
            });
        };

        initMap();
    }, []);

    return <div id="map" style={{ height: '100%', width: '100%', marginInline: 'auto' }}></div>;
};

// COMPONENTES ESTILIZADOS
const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(

    ({ theme, open }) => ({
        display: window.innerWidth >= 960 ? 'grid' : null,
        gridTemplateColumns: 'repeat(auto-fit, 400px)',
        justifyContent: 'center',
        columnGap: 16,
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        ...(open && {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
        }),
    }),
);

// ELEMENTO ESTILIZADO
function MediaMobile(props) {
    const { loading = false } = props;
    const navigate = useNavigate();

    // Estado para alternar la altura
    const [isHeightIncreased, setIsHeightIncreased] = React.useState(true);
    const [eventLocation, setEventLocation] = useState(props.event.eventLocation);

    let [showCalendar, setShowCalendar] = useState(false);
    let [showMiniMap, setShowMiniMap] = useState(false);
    let [traducedDay, setTraducedDay] = useState('');
    let [traducedMonth, setTraducedMonth] = useState('');

    const traducirDia = (dia) => {
        switch (dia.split("-")[1]) {
            case '01':
                setTraducedMonth("Enero");
                break;
            case '02':
                setTraducedMonth("Febrero");
                break;
            case '03':
                setTraducedMonth("Marzo");
                break;
            case '04':
                setTraducedMonth("Abril");
                break;
            case '05':
                setTraducedMonth("Mayo");
                break;
            case '06':
                setTraducedMonth("Junio");
                break;
            case '07':
                setTraducedMonth("Julio");
                break;
            case '08':
                setTraducedMonth("Agosto");
                break;
            case '09':
                setTraducedMonth("Sept");
                break;
            case '10':
                setTraducedMonth("Octubre");
                break;
            case '11':
                setTraducedMonth("Noviembre");
                break;
            case '12':
                setTraducedMonth("Diciembre");
                break;
            default:
                break;
        }

        var hora = dia.split("-")[2]

        setTraducedDay(hora.split("T")[0])

    }

    const openEventDetails = () => {
        store.dispatch(EVENTDETAILS_action(props.event))
        // navigate("/eventdetails/" + props.event.EventID)
        navigate("/event/" + props.event.slug)
        // return <Navigate to="/createevent" />;
    }

    // Función para aumentar la altura del `Media`
    const toggleHeight = () => {
        // setHeight((prevHeight) => prevHeight + 50); // Incrementa la altura en 50px
        setIsHeightIncreased((prev) => !prev);
    };

    useEffect(() => {
        if (props.event.eventLocationCoords != "") {

            const geocoder = new window.google.maps.Geocoder();
            const location = JSON.parse(props.event.eventLocationCoords);

            geocoder.geocode({ location: location }, (results, status) => {
                if (status === "OK" && results[0]) {
                    setEventLocation(results[0].formatted_address);
                } else {
                    console.error("Fallo en la geocodificación inversa: " + status);
                }
            });
        }
    }, []);

    return (
        <>
            {showMiniMap ? (
                <Box sx={{ p: 0, position: 'relative', height: 220, mb: 2 }}>
                    <div style={{ height: '100%' }} onClick={(e) => e.stopPropagation()}>
                        <Map location={JSON.parse(props.event.eventLocationCoords)} />
                        <IconButton
                            sx={{
                                position: 'absolute',
                                bottom: 20,
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bgcolor: 'rgba(63, 81, 181, 0.8)',
                                '&:hover': {
                                    bgcolor: 'rgba(63, 81, 181, 0.9)'
                                }
                            }}
                            onClick={() => setShowMiniMap(false)}
                        >
                            <KeyboardBackspaceRoundedIcon sx={{ color: 'white' }} />
                        </IconButton>
                    </div>
                </Box>
            ) : (
                <Box
                    sx={{
                        position: 'relative',
                        paddingTop: '220px',
                        marginBottom: 4,
                        borderRadius: 1,
                        overflow: 'hidden',
                        '&:hover .info-overlay': {
                            height: '100%',
                        },
                        '&:hover .button-container': {
                            opacity: 1,
                            transform: 'translateY(0)',
                        }
                    }}
                >
                    {props.event.eventImage ? (
                        <Box
                            component="img"
                            src={`${props.event.eventImage}?sp=racwdli&st=2025-03-10T21:49:45Z&se=2026-08-06T05:49:45Z&spr=https&sv=2022-11-02&sr=c&sig=GcXlifAeQNMN09HG4bkOXCZGmZSNVlc55Aa075L2l5Q%3D`}
                            alt={`Post ${props.event.eventTitle}`}
                            sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                            }}
                        />
                    ) : (
                        <Box
                            sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                background: `linear-gradient(45deg, 
                                    rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, 1),
                                    rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, 1)
                                )`,
                                //     background: `linear-gradient(45deg, 
                                //     rgba(22, 145, 40, 1),
                                //     rgba(71, 150, 180, 1)
                                // )`,
                                backgroundColor: 'white',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <PartyModeIcon sx={{ fontSize: 80, color: 'white', opacity: 0.6 }} />
                        </Box>
                    )}

                    <Box
                        className="info-overlay"
                        sx={{
                            position: 'absolute',
                            bottom: 0,
                            width: '100%',
                            height: '70%',
                            background: props.event.eventImage && 'linear-gradient(transparent, rgba(0,0,0,0.95))',
                            padding: 2.5,
                            color: 'white',
                            boxSizing: 'border-box',
                            backdropFilter: props.event.eventImage ? 'blur(5px)' : 'blur(2px)',
                            transition: 'all 0.3s ease-in-out',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Stack spacing={1.5}>
                            <Typography
                                variant={'h5'}
                                sx={{
                                    fontWeight: 700,
                                    color: 'white',
                                    textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    letterSpacing: '0.5px',
                                    animation: 'fadeIn 0.5s ease-in',
                                    '@keyframes fadeIn': {
                                        from: { opacity: 0, transform: 'translateY(20px)' },
                                        to: { opacity: 1, transform: 'translateY(0)' }
                                    }
                                }}
                            >
                                {props.event.eventTitle}
                            </Typography>

                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                <Avatar
                                    src={`${props.event.creatorAvatar}?sp=racwdli&st=2025-03-10T21:49:45Z&se=2026-08-06T05:49:45Z&spr=https&sv=2022-11-02&sr=c&sig=GcXlifAeQNMN09HG4bkOXCZGmZSNVlc55Aa075L2l5Q%3D`}
                                    sx={{
                                        width: '1rem',
                                        height: '1rem'
                                    }}
                                />
                                <Typography
                                    variant="body2"
                                    color={'white'}
                                    sx={{
                                        opacity: 0.85,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        lineHeight: 1.6,
                                        fontSize: '0.95rem',
                                        fontWeight: 300,
                                        letterSpacing: '0.3px',
                                        fontStyle: 'italic',
                                        textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
                                        fontFamily: '"Segoe UI", Arial, sans-serif'
                                    }}
                                >
                                    {props.event.creatorName}
                                </Typography>
                            </Box>

                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <CalendarMonthOutlinedIcon sx={{ fontSize: '1rem', opacity: 0.9, color: 'white' }} />
                                <Typography
                                    variant="subtitle2"
                                    sx={{
                                        opacity: 0.9,
                                        fontWeight: 500,
                                        fontSize: '0.9rem',
                                        color: 'white',
                                        fontFamily: '"Roboto", sans-serif'
                                    }}
                                >
                                    {(new Date(props.event.startDay)).toLocaleDateString("es-ES", {
                                        day: 'numeric',
                                        month: 'long',
                                        year: 'numeric'
                                    })} • {props.event.startHour}
                                    {props.event.startHour.split(":")[0] >= 12 ? ' PM' : ' AM'}
                                </Typography>
                            </Box>

                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <LocationOnIcon sx={{ fontSize: '1rem', opacity: 0.9, color: 'white' }} />
                                <Typography
                                    variant="subtitle2"
                                    sx={{
                                        opacity: 0.9,
                                        color: 'white',
                                        fontWeight: 500,
                                        fontSize: '0.9rem',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        fontFamily: '"Roboto", sans-serif'
                                    }}
                                >
                                    {props.event.eventLocation || "Ubicación no especificada"}
                                </Typography>
                            </Box>
                        </Stack>

                        <Box sx={{
                            display: 'flex',
                            gap: 2,
                            mt: 3,
                            height: '48px' // Fixed height for buttons
                        }}>
                            {props.event.eventLocation && (

                                <Button
                                    className='button-container'
                                    variant="contained"
                                    startIcon={<LocationOnIcon />}
                                    fullWidth
                                    sx={{
                                        bgcolor: 'rgba(63, 81, 181, 0.8)',
                                        height: '100%',
                                        borderRadius: 4,
                                        opacity: 0,
                                        flex: 2 // Takes up 2 parts of available space
                                    }}
                                    onClick={(e) => {
                                        if (props.event.eventLocation) {
                                            e.stopPropagation();
                                            setShowMiniMap(true);
                                        }
                                    }}
                                >
                                    Ver ubicación
                                </Button>
                            )}
                            <Button
                                    className='button-container'
                                variant="contained"
                                color="success"
                                // startIcon={<Visibility />}
                                sx={{
                                    height: '100%',
                                    borderRadius: 4,
                                    opacity: 0,
                                    flex: 1 // Takes up 1 part of available space
                                }}
                                onClick={() => openEventDetails(props.event)}
                            >
                                <Visibility />
                                {/* Ver */}
                            </Button>
                        </Box>
                    </Box>
                </Box>
            )}
        </>


    );


}


function MediaWeb(props) {
    const { loading = false } = props;
    const navigate = useNavigate();
    const [eventLocation, setEventLocation] = useState(props.event.eventLocation);
    const [isHovered, setIsHovered] = useState(false);

    const openEventDetails = () => {
        store.dispatch(EVENTDETAILS_action(props.event))
        navigate("/event/" + props.event.slug)
    }

    useEffect(() => {
        if (props.event.eventLocationCoords) {
            const geocoder = new window.google.maps.Geocoder();
            const location = JSON.parse(props.event.eventLocationCoords);

            geocoder.geocode({ location: location }, (results, status) => {
                if (status === "OK" && results[0]) {
                    setEventLocation(results[0].formatted_address);
                } else {
                    console.error("Fallo en la geocodificación inversa: " + status);
                }
            });
        }
    }, [props.event.eventLocationCoords]);

    return (
        <Card
            elevation={isHovered ? 4 : 1}
            sx={{
                maxWidth: 400,
                mb: 4,
                borderRadius: 4,
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                '&:hover': {
                    transform: 'translateY(-4px)'
                }
            }}
            onClick={openEventDetails}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {props.event.eventImage ? (
                <CardMedia
                    component="img"
                    height="200"
                    image={`${props.event.eventImage}?sp=racwdli&st=2025-03-10T21:49:45Z&se=2026-08-06T05:49:45Z&spr=https&sv=2022-11-02&sr=c&sig=GcXlifAeQNMN09HG4bkOXCZGmZSNVlc55Aa075L2l5Q%3D`}
                    sx={{ borderRadius: '16px 16px 0 0' }}
                />
            ) : (
                <Box
                    sx={{
                        height: 200,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: 'grey.100',
                        borderRadius: '16px 16px 0 0'
                    }}
                >
                    <Avatar
                        src={`${props.event.creatorAvatar}?sp=racwdli&st=2025-03-10T21:49:45Z&se=2026-08-06T05:49:45Z&spr=https&sv=2022-11-02&sr=c&sig=GcXlifAeQNMN09HG4bkOXCZGmZSNVlc55Aa075L2l5Q%3D`}
                        sx={{
                            width: 120,
                            height: 120,
                            mb: 2,
                            transition: 'all 0.2s ease-in-out',
                            '.MuiCard-root:hover &': {
                                width: 130,
                                height: 130
                            }
                        }}
                    />
                    <Typography variant="subtitle1" fontWeight="medium" color="text.secondary">
                        {props.event.creatorName}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        Creador del evento
                    </Typography>
                </Box>
            )}

            <CardContent>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            mb: 2
                        }}>
                            <Typography variant="h6" sx={{ fontWeight: 'medium' }} fontFamily={'Trebuchet MS'}>
                                {props.event.eventTitle}
                            </Typography>
                            {/* <Chip
                                label={props.event.eventPrivacity === "PUBLICO" ? "Público" : "Privado"}
                                color={props.event.eventPrivacity === "PUBLICO" ? "primary" : "warning"}
                                size="small"
                            /> */}
                        </Box>
                    </Grid>

                    <Grid item xs={12}>
                        <Paper
                            elevation={0}
                            sx={{
                                p: 2,
                                // bgcolor: isHovered ? 'primary.light' : 'grey.50',
                                bgcolor: 'grey.50',
                                borderRadius: 2,
                                transition: 'background 0.3s ease'
                            }}
                        >
                            <Grid container spacing={2} alignItems="center">
                                <Grid item>
                                    <Avatar sx={{ bgcolor: isHovered ? 'primary.dark' : 'primary.main' }} src={`${props.event.creatorAvatar}?sp=racwdli&st=2025-03-10T21:49:45Z&se=2026-08-06T05:49:45Z&spr=https&sv=2022-11-02&sr=c&sig=GcXlifAeQNMN09HG4bkOXCZGmZSNVlc55Aa075L2l5Q%3D`}>
                                        {/* <PersonIcon /> */}
                                    </Avatar>
                                </Grid>
                                <Grid item xs>
                                    <Typography fontFamily={'Fredoka, sans-serif'}>{props.event.creatorName}</Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>

                    <Grid item xs={12}>
                        <Paper
                            elevation={0}
                            sx={{
                                p: 2,
                                // bgcolor: isHovered ? 'primary.light' : 'grey.50',
                                bgcolor: 'grey.50',
                                borderRadius: 2,
                                transition: 'background 0.3s ease'
                            }}
                        >
                            <Grid container spacing={2} alignItems="center">
                                <Grid item>
                                    <Avatar sx={{ bgcolor: isHovered ? 'primary.dark' : 'primary.main' }}>
                                        <CalendarMonthOutlinedIcon />
                                    </Avatar>
                                </Grid>
                                <Grid item xs>
                                    <Typography fontFamily={'Fredoka, sans-serif'}>
                                        {(new Date(props.event.startDay)).toLocaleDateString("es-ES")}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" fontFamily={'Fredoka, sans-serif'}>
                                        {props.event.startHour}
                                        {props.event.startHour.split(":")[0] >= 12 ? ' PM' : ' AM'}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>

                    <Grid item xs={12}>
                        <Paper
                            elevation={0}
                            sx={{
                                p: 2,
                                // bgcolor: isHovered ? 'primary.light' : 'grey.50',
                                bgcolor: 'grey.50',
                                borderRadius: 2,
                                transition: 'background 0.3s ease'
                            }}
                        >
                            <Grid container spacing={2} alignItems="center">
                                <Grid item>
                                    <Avatar sx={{ bgcolor: isHovered ? 'primary.dark' : 'primary.main' }}>
                                        <LocationOnIcon />
                                    </Avatar>
                                </Grid>
                                <Grid item xs>
                                    <Typography fontFamily={'Fredoka, sans-serif'}>
                                        {props.event.eventLocation || "Ubicación no especificada"}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}

MediaMobile.propTypes = {
    loading: PropTypes.bool,
};



// MAIN
// const FloatingActionButton = () => {
//     const navigate = useNavigate();
//     const [open, setOpen] = useState(false);

//     const actions = [
//         { icon: <EventIcon />, name: 'Crear Evento', action: () => navigate('/createevent') }
//     ];

//     return (
//         <>
//             <Box
//                 sx={{
//                     position: 'fixed',
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     bottom: 0,
//                     bgcolor: 'rgba(0, 0, 0, 0.5)',
//                     zIndex: (theme) => theme.zIndex.speedDial - 1,
//                     transition: 'opacity 0.3s',
//                     opacity: open ? 1 : 0,
//                     pointerEvents: open ? 'auto' : 'none',
//                 }}
//                 onClick={() => setOpen(false)}
//             />
//             <SpeedDial
//                 ariaLabel="SpeedDial"
//                 sx={{
//                     position: 'fixed',
//                     bottom: 32,
//                     right: 32,
//                     '& .MuiFab-primary': {
//                         bgcolor: '#3f51b5',
//                         '&:hover': {
//                             bgcolor: '#303f9f'
//                         }
//                     }
//                 }}
//                 icon={<SpeedDialIcon openIcon={<CloseIcon />} />}
//                 onClose={() => setOpen(false)}
//                 onOpen={() => { setOpen(true) }}
//                 open={open}
//             >
//                 {actions.map((action) => (
//                     <SpeedDialAction
//                         key={action.name}
//                         icon={action.icon}
//                         tooltipTitle={action.name}
//                         onClick={action.action}
//                         tooltipOpen
//                         sx={{
//                             '&.MuiSpeedDialAction-fab': {
//                                 bgcolor: '#f5f5f5',
//                                 '&:hover': {
//                                     bgcolor: '#e0e0e0'
//                                 },
//                                 width: 'auto',
//                                 paddingInline: 2
//                             },
//                             '& .MuiSpeedDialAction-staticTooltipLabel': {
//                                 // backgroundColor: 'transparent',
//                                 color: 'inherit',
//                                 fontSize: '0.875rem',
//                                 marginLeft: 1,
//                                 whiteSpace: 'nowrap'
//                             }
//                         }}
//                     />
//                 ))}
//             </SpeedDial>
//         </>
//     );
// };

const PrivatedEvents = (props) => {
    let [actualVersion, setActualVersion] = useState(63);
    let [actualVersion2, setActualVersion2] = useState(0);
    let [showModalActualizacionPendiente, setShowModalActualizacionPendiente] = useState(false);


    let [publicKey, setPublicKey] = useState('');
    let statePublicKey = '';
    let [privateKey, setPrivateKey] = useState('');
    let statePrivatecKey = '';

    const location = useLocation();
    const { token } = location.state || {}; // Accede al token desde location.state
    let [loadingPage, setLoadingPage] = useState(true)

    let [showModalError, setShowModalError] = useState(false)
    let [errorMsg, setErrorMsg] = useState('')

    let [contenedorSEC, setContenedorSEC] = useState('')
    let [contenedorSET, setContenedorSET] = useState('')

    const [isLargeScreen, setIsLargeScreen] = useState(null); // Mide el tamaño de la pantalla para hacer el diseño responsive
    const navigate = useNavigate()

    // Datos para la creacion de un evento
    const [eventName, setEventName] = useState('')
    const [eventDescription, setEventDescription] = useState('')
    const [eventCreator, setEventCreator] = useState('(Nombre del usuario actual)')
    let [eventType, setEventType] = useState('')
    // const [eventHour, setEventHour] = useState('15:00') // Hora del evento a crear

    const [eventHour, setEventHour] = useState(null)
    const [traducedHour, setTraducedHour] = useState(null)

    const [selectedDate, setSelectedDate] = useState(null)
    const [traducedDate, setTraducedDate] = useState(null)

    const hasExecuted = useRef(false);
    const [events, setEvents] = useState([])
    const [eventsList, setEventsList] = useState([])
    let [publicEvents, setPublicEvents] = useState([])
    let [privateEvents, setPrivateEvents] = useState([])
    let [mainEvents, setMainEvents] = useState([])

    const eventoHarcodeado = { creatorAvatar: "avatar", creatorId: 1, creatorName: "EventEase", eventCharacteristics: "estos son los.\ndetalles", eventDescription: "Crea tu primer evento con EventEase y sal un poco de casa!", eventID: -1, eventImage: "imagen", eventLocation: "Argentina", eventPrivacity: "PUBLICO", eventTitle: "Bienvenido a EventEase!", eventType: "No definido", guestsId: '', startDay: "15 de abril de 2024", startHour: "07:17" }

    const [datos, setDatos] = useState()

    const [filter, setFilter] = useState([
        { id: 0, title: 'Todos', selected: true, icon: <AllInclusiveIcon style={{ color: '#00bcd4' }}></AllInclusiveIcon> },
        { id: 1, title: 'Publicos', selected: false, icon: <PublicIcon style={{ color: '#00bcd4' }}></PublicIcon> },
        { id: 2, title: 'Privados', selected: false, icon: <HttpsIcon style={{ color: '#00bcd4' }}></HttpsIcon> },
        { id: 3, title: 'Creados por mi', selected: false, icon: <StarBorderIcon style={{ color: '#00bcd4' }}></StarBorderIcon> },
    ])

    const [traducedFilter, setTraducedFilter] = useState('')


    const [modalCreateEvent, setModalCreateEvent] = useState(false) // Modal para crear un evento
    const [selectedIndex, setSelectedIndex] = React.useState(0); // Filtro para mostrar Todos, Publicos o Privados

    let closeintro = false;
    let [closedintro, setClosedintro] = useState(true);


    // FUNCION PARA CREAR EVENTOS
    function goCreateEvent() {
        if (props.user.email !== '') {
            navigate('/createevent')
        } else {
            navigate('/login')
        }
    }
    function closeIntro() {
        closeintro = !closeintro;
        setClosedintro(closeintro);
    }
    function ChangeFilter(item) {
        const updatedFilter = filter.map(filterItem => {
            return { ...filterItem, selected: filterItem.id === item.id }
        })
        let filtrosActualizados = updatedFilter
        setFilter(filtrosActualizados)
    }


    // function decryptData(encryptedData) {
    //     // Convertimos la cadena en Base64 a palabras
    //     const encryptedBytes = CryptoJS.enc.Base64.parse(encryptedData);

    //     // Extraemos el IV (primeros 16 bytes)
    //     const iv = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(0, 4), 16);

    //     // Extraemos el texto encriptado (bytes restantes)
    //     const cipherText = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(4));

    //     // Clave utilizada
    //     const key = CryptoJS.enc.Utf8.parse("AKeyThatIsAtLeast32CharactersLongForHS256");

    //     // Desencriptamos
    //     const decrypted = CryptoJS.AES.decrypt({ ciphertext: cipherText }, key, {
    //         iv: iv,
    //         mode: CryptoJS.mode.CBC,
    //         padding: CryptoJS.pad.Pkcs7
    //     });

    //     return decrypted.toString(CryptoJS.enc.Utf8);
    // }



    function decryptData(encryptedText) {
        // Define la misma clave que usaste en el backend
        const key = "AKeyThatIsAtLeast32CharactersLongForHS256";

        // Decodifica el texto encriptado de base64
        const encryptedBytes = CryptoJS.enc.Base64.parse(encryptedText);

        // Extrae el IV (los primeros 16 bytes) y el contenido encriptado
        const iv = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(0, 4), 16);
        const encryptedContent = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(4));

        // Deriva la clave usando SHA256
        const hashedKey = CryptoJS.SHA256(key);

        // Desencripta el contenido
        const decrypted = CryptoJS.AES.decrypt(
            { ciphertext: encryptedContent },
            hashedKey,
            {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }
        );

        // Convierte el resultado a texto legible
        return decrypted.toString(CryptoJS.enc.Utf8);
    }






    async function GetEvents() {
        setLoadingPage(true)


        let privacidad = ''
        let filtroSeleccionado
        let eventosAgregados = 0


        filter.map((item, index) => {
            if (filter[index].selected == true) {
                filtroSeleccionado = item
            }
        })


        if (filtroSeleccionado.title == 'Publicos') {
            privacidad = 'PUBLICO'
        } else if (filtroSeleccionado.title == 'Privados') {
            privacidad = 'PRIVADO'
        } else if (filtroSeleccionado.title == 'Todos') {
            privacidad = ''
        } else if (filtroSeleccionado.title == 'Creados por mi') {
            privacidad = 'MIOS'
        }

        if (props.searchEventTitle !== undefined) {

            setContenedorSET(props.searchEventTitle)
        }

        if (props.searchEventCreator !== undefined) {

            setContenedorSEC(props.searchEventCreator)
        }



        let request1 = (privacidad !== '' ? privacidad : '')
        let request2 = (privacidad !== '' && props.searchEventTitle !== undefined) ? '&' : '';
        let request3 = (contenedorSET !== '') ? 'title=' + contenedorSET : ''
        let request4 = (contenedorSEC !== '') ? 'creatorName=' + contenedorSEC : ''

        let request = request1 + request2 + request3 + request4

        const token = localStorage.getItem('jwt_token');

        let data;
        let userData;

        if (localStorage.getItem('userData') !== null && localStorage.getItem('userData') !== undefined && localStorage.getItem('userData') !== "null") {

            const userDataString = localStorage.getItem('userData'); // Obtiene la cadena JSON de localStorage
            userData = JSON.parse(userDataString); // Convierte la cadena JSON a un objeto

            store.dispatch(LOGIN_USER_action(userData))
            store.dispatch(TOKEN_action(localStorage.getItem('jwt_token')))



            var userID = userData.userID
            data = {
                title: props.searchEventTitle,
                // creatorName: props.user.nombre,
                eventPrivacity: privacidad,
                // creatorID: contenedorSEC,
                userID: userID,
                creatorID: 0


            }
        } else {

            data = {
                title: props.searchEventTitle,
                // creatorName: props.user.nombre,
                eventPrivacity: privacidad,
                // creatorID: contenedorSEC,
                userID: (props.user.id) ? props.user.id : 0,
                creatorID: 0


            }
        }

        const jsonData = JSON.stringify(data);

        const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

        const headers = 'content-type: application/json; charset=utf-8'
        // withCredentials: true

        // let headers = { Authorization: `Bearer ${props.token}` };

        await axios.post(`https://socializeapi.azurewebsites.net/api/GetEvents`, data, {
            headers
        })
            .then(response => {
                // let decripted_response = decryptData(response.data)


                if (localStorage.getItem('userData') !== "null" && localStorage.getItem('userData') !== null && localStorage.getItem('userData') !== "") {

                    const mainEvents = JSON.parse(localStorage.getItem('userData')).userID ? response.data.filter(item => userData.userID == item.creatorId && item.eventPrivacity == "PRIVADO") : [];
                    const publicEvents = response.data.filter(item => item.eventPrivacity === "PUBLICO");
                    const privateEvents = JSON.parse(localStorage.getItem('userData')).userID ? response.data.filter(item => (item.eventPrivacity === "PRIVADO" && item.guestsId.includes(userData.userID.toString() + ";")) || (item.eventPrivacity == "PRIVADO" && item.creatorId == userID)) : [];


                    const combinedEvents = mainEvents.concat(privateEvents);

                    const uniqueCombinedEvents = [...new Set(combinedEvents)];

                    // const sortedCombinedEvents = uniqueCombinedEvents.sort((a, b) => new Date(a.eventDate) - new Date(b.eventDate));
                    const oneWeekAgo = new Date();
                    oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);

                    // Filter events within the last week and sort them
                    const sortedCombinedEvents = uniqueCombinedEvents
                        .filter(event => {
                            const eventDate = new Date(`${event.startDay.split("T")[0]}T${event.startHour}`);
                            return eventDate >= oneWeekAgo;
                        })
                        .sort((a, b) => {
                            // Create Date objects combining eventDate and startHour
                            const dateA = new Date(`${a.startDay.split("T")[0]}T${a.startHour}`);
                            const dateB = new Date(`${b.startDay.split("T")[0]}T${b.startHour}`);

                            // Compare combined dates and times
                            return dateA - dateB;
                        });

                    let eventList = sortedCombinedEvents

                    console.log(eventList)

                    setMainEvents(mainEvents);
                    setPublicEvents(publicEvents);
                    setPrivateEvents(privateEvents);
                    setEventsList(eventList);
                    setEvents(eventList)
                } else {

                    const publicEvents = response.data.filter(item => item.eventPrivacity === "PUBLICO");

                    setEvents(publicEvents)

                }


                setLoadingPage(false)
            })
            .catch(error => {
                console.log(`Error obteniendo los eventos: ${error}`);
            })
    }


    const GetAvatar = () => {

        const data = {
            "UserID": JSON.parse(localStorage.getItem('userData')).userID,
        }
        const jsonData = JSON.stringify(data);
        const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

        const headers = 'content-type: application/json; charset=utf-8'

        axios.post('https://socializeapi.azurewebsites.net/api/GetAvatar', { data: data_encripted }, {
            headers: { 'Content-Type': 'application/json; charset=utf-8' }
        })
            .then(response => {
                const imageUrl = response.data.avatar;

                var user = localStorage.getItem('userData')

                var parsedUser = JSON.parse(user);
                parsedUser.avatar = imageUrl

                localStorage.setItem('userData', JSON.stringify(parsedUser))
            })
            .catch(error => {
                console.log(`Error obteniendo datos: ${error}`);
            });
    }

    async function RegisterDevice() {
        let FCMtoken = '';
        let userAgent = navigator.userAgent;
        let Device = "";

        console.log("userAgent")
        console.log(userAgent)
        // if (/android/i.test(userAgent)) {
        //   userAgent = "android";
        //   requestPermissions();
        //   FCMtoken = getFCMToken();
        // } else if (/iPad|iPhone|iPod/.test(userAgent)) {
        //   userAgent = "ios";
        //   requestPermissions();
        //   FCMtoken = getFCMToken();
        // } else {
        //   userAgent = "web";
        // }
        try {
            if (userAgent.includes("Android")) {
                Device = " android";
                requestPermissions();
                FCMtoken = await getFCMToken();


            } else if (userAgent.includes("iPad") || userAgent.includes("iPhone") || userAgent.includes("iPod")) {
                Device = "ios";
                requestPermissions();
                FCMtoken = await getFCMToken();
            } else {
                Device = "web";
            }

            let data = {
                UserId: JSON.parse(localStorage.getItem('userData')).userID,
                UserAgent: Device,
                Token: FCMtoken
            }

            console.log("data")
            console.log(data)

            const headers = 'content-type: application/json; charset=utf-8'
            axios.post('https://socializeapi.azurewebsites.net/api/register-device', data, { headers });

        } catch (error) {
            console.log("Error al registrar el dispositivo: " + error)
            // setShowModalError(true);
            // setErrorMsg(error.toString())
        }

    }


    async function getUserInfo() {

        const token = localStorage.getItem('jwt_token');

        const data = {
            // "UserID": 5051, // Modo desarrollo
            "UserID": 1080, // Modo produccion
        }
        const jsonData = JSON.stringify(data);
        const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

        const headers = 'content-type: application/json; charset=utf-8'

        await axios.post('https://socializeapi.azurewebsites.net/api/GetUser', { data: data_encripted }, {
            headers
        })
            .then(response => {
                // Check if both values are valid numbers before comparing
                const currentVersion = Number(actualVersion);
                const serverVersion = Number(response.data.telephone);

                if (!isNaN(currentVersion) && !isNaN(serverVersion) && currentVersion !== serverVersion) {
                    setActualVersion2(response.data.telephone);
                    console.log("version diferente");
                    setShowModalActualizacionPendiente(true);
                }
            })
            .catch(error => {
                console.log(`Error obteniendo datos: ${error}`);
            });
    }


    useEffect(() => {
        if (hasExecuted.current) return;
        hasExecuted.current = true;

        GetEvents();

        console.log(localStorage.getItem('userData'))
        if (localStorage.getItem('userData') !== "null" && localStorage.getItem('userData') !== "" && localStorage.getItem('userData') !== null) {
            // if (navigator.userAgent.includes("Android")) {

            //     getUserInfo();
            // }
            // RegisterDevice()
            GetAvatar();
        }

        const handleResize = () => {
            setIsLargeScreen(window.innerWidth >= 960); // set the breakpoint here
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (filter[0].selected === true) {
            console.log("eventsList")
            console.log(eventsList)
            setEvents(eventsList);
        } else if (filter[1].selected === true) {
            console.log("publicEvents")
            console.log(publicEvents)
            setEvents(publicEvents);
        } else if (filter[2].selected === true) {
            console.log("privateEvents")
            console.log(privateEvents)
            setEvents(privateEvents);
        } else {
            console.log("mainEvents")
            console.log(mainEvents)
            setEvents(mainEvents);
        }
    }, [filter]);


    async function obtenerVAPID() {
        const headers = 'content-type: application/json; charset=utf-8'

        await axios.get(`https://socializeapi.azurewebsites.net/api/getvapid`, null, { headers })
            .then(response => {
                if (response.data !== null) {
                    setPublicKey(response.data.value.keys.publicKey)
                    statePublicKey = response.data.value.keys.publicKey
                    setPrivateKey(response.data.value.keys.privateKey)
                    statePrivatecKey = response.data.value.keys.privateKey
                }

            })
            .catch(error => {
                console.log(`Error obteniendo datos: ${error}`);
            });
    }

    return (
        <div style={{ backgroundColor: '#F5F5F5' }}>
            <Header></Header>
            <div style={{
                display: 'flex',
                width: '100%',
                minHeight: '100vh',
            }}>
                {isLargeScreen ? (<Sidebar></Sidebar>) : (<SidebarResponsive></SidebarResponsive>)}
                <div style={{ marginTop: 100, width: '100%' }}>


                    <Main style={{ marginTop: props.user.id ? 0 : 140 }}>
                        {loadingPage ? (
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <div className="skeleton-card">
                                    <div style={{ height: 200 }}></div>
                                    <div className="skeleton-text skeleton-title"></div>
                                    <div className="skeleton-text skeleton-subtitle"></div>
                                    <div className="skeleton-text skeleton-date"></div>
                                    <div className="skeleton-text skeleton-location"></div>
                                </div>
                                {/* {isLargeScreen ? (
                                ) : (
                                    <div className="skeleton-card-responsive">
                                        <div className="skeleton-text-responsive skeleton-title-responsive"></div>
                                        <div className="skeleton-text-responsive skeleton-subtitle-responsive"></div>
                                    </div>
                                )} */}


                            </div>
                        ) : (
                            events.length === 0 ? (
                                <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                    <Typography>No hay eventos para mostrarte</Typography>
                                    <Typography>Crea un evento de manera rápida y sencilla!</Typography>
                                </div>
                            ) : (
                                isLargeScreen ? (

                                    events.map((item, index) => (
                                        <MediaWeb
                                            key={index}
                                            event={item}
                                            isLargeScreen={isLargeScreen}
                                        />
                                    ))

                                ) : (
                                    events.map((item, index) => (
                                        <MediaMobile
                                            key={index}
                                            event={item}
                                            isLargeScreen={isLargeScreen}
                                        />
                                    ))
                                )
                            )
                        )}
                    </Main>


                </div>
            </div >

            {/* Invoca los Bottones del Bottom */}
            {!isLargeScreen && (
                <>
                    <FloatingActionButton />
                    <BottomNavigationBar />
                </>
            )}


            <footer style={{ marginTop: 32, marginLeft: (isLargeScreen ? 48 : null), textAlign: 'center', color: 'grey' }}>
                © 2024 HiSocialize. Todos los derechos reservados.
            </footer>


            <Modal
                open={showModalError}
                onClose={() => { setShowModalError(false) }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: (isLargeScreen ? 400 : 300),
                    bgcolor: 'background.paper',
                    // border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: '0.5em'
                }}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        {errorMsg}
                    </Typography>


                    <Button variant="contained" color='success' onClick={() => { setShowModalError(false) }} style={{ marginTop: 16, width: (isLargeScreen ? 400 : 300), marginBottom: 16 }}>
                        OK
                    </Button>
                </Box>
            </Modal>

        </div >
    )




}

export default connect(mapStateToProps)(PrivatedEvents);